import { SVGProps } from 'react';

const JobsIcon = ({
  height = '24px',
  width = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    {...props}
  >
    <rect
      width='20'
      height='14'
      rx='2'
      transform='translate(2 6.95)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='bevel'
      strokeWidth='2'
    />
    <path
      d='M7,7V5.05a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V7'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='bevel'
      strokeWidth='2'
      fillRule='evenodd'
    />
  </svg>
);

export default JobsIcon;
